import React, { Component } from 'react';
import RkHeader from '../GeneralComponents/RkHeader'
import WebpackerReact from 'webpacker-react';
import FishboneChart from '../components/Causes/CauseAnalysis/FishboneChart'
import FormCreate from '../components/formatos/Formats/FormCreate';
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Loading from '../GeneralComponents/LoadingComponen'
import { UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import TasksItems from '../components/tasks/tasksNumeralChildScore/TasksItems'
import TaskFormCreate from '../components/tasks/tasksNumeralChildScore/FormCreate'
import GeneralComments from '../GeneralComponents/ChatBoxModuleComment'
import FormUpdate from '../components/formatos/Formats/FormCreate'
import IndexTaskModule from '../components/tasks/taskBoard/IndexTaskModule'

class CauseAnalysisShow extends Component {
    constructor(props) {
        super(props);
        this.url_source = `/cause/cause_analyses/${this.props.cause_analysis.id}`
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            dataTable: [],
            users: [],
            isLoaded: true,
            activeTab: 'factores',
            boardKey: 0,
            showTask: false,
            modal: false,
            modalEdit: false,
            idTask: "",
            register: {},
            form: {
                name: "",
                cause_analysis_id: this.props.cause_analysis.id,
            },

            formUpdate: {
                id: "",
                title: "",
            },

            modalFactor: false,
            formFactor: {
                id: "",
                name: "",
            },
        }
    }

    componentDidMount() {
        this.loadData();
        this.setDefaultValues();
    }

    setDefaultValues = () => {
        let array = []

        this.props.users.map((item) => (
            array.push({ label: item.name, value: item.id })
        ))

        this.setState({
            users: array
        })
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    }

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => {
                if (format.id === item.id) {
                    return {
                        ...item,
                        name: format.name,
                    }
                }
                return item;
            })
        });
    }

    clearValues = () => {
        this.setState({
            form: {
                ...this.state.form,
                name: "",
            }
        });
    }

    get_name = (name) => {
        if (name == "FP") {
            return "FACTORES DE PACIENTE"
        } else if (name == "FT") {
            return "Factores de Tarea"
        } else if (name == "FFE") {
            return "FACTORES DE FORMACIÓN Y ENTRENAMIENTO"
        } else if (name == "FC") {
            return "FACTORES DE COMUNICACIÓN"
        } else if (name == "FES") {
            return "FACTORES SOCIALES Y DE EQUIPO"
        } else if (name == "FER") {
            return "FACTORES DE EQUIPAMIENTO Y RECURSOS"
        } else if (name == "CT") {
            return "CONDICIONES DE TRABAJO"
        } else if (name == "FOE") {
            return "FACTORES ORGANIZATIVOS Y ESTRATÉGICOS"
        } else if (name == "FI") {
            return "FACTORES INDIVIDUALES"
        }
    }

    loadData = () => {
        fetch(`/cause/get_show_data/${this.props.cause_analysis.id}`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    data: data.data,
                    dataTable: data.dataTable,
                    isLoaded: false
                });
            });
    }

    // Recarga la tabla de factores/componentes Y remonta el Kanban (bump key) para que
    // refetchee sus tareas — usado tras crear/editar/eliminar tareas desde el pin.
    reloadAll = () => {
        this.loadData();
        this.setState({ boardKey: this.state.boardKey + 1 });
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true })
            this.clearValues();
        } else {
            this.setState({ modal: false })
        }
    }

    toogleMejora = (from) => {
        if (from == "new") {
            this.setState({ modalEdit: true })
        } else {
            this.setState({ modalEdit: false })
        }
    }

    HandleClick = () => {
        fetch("/cause/factors", {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(this.state.form), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.clearValues();
                this.loadData();
                this.setState({ modal: false })
            });
    }

    HandleClickUpdate = () => {
        fetch(`/cause/sub_factor_items/${this.state.formUpdate.id}`, {
            method: 'PATCH', // or 'PUT'
            body: JSON.stringify(this.state.formUpdate), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.loadData();
                this.messageSuccess(data);
                this.setState({ modalEdit: false })
            });
    }

    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    }


    delete = (sub_factor_item, factor) => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/cause/remove/${sub_factor_item}/${factor}`, {
                    method: "POST",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.loadData()
                        this.messageSuccess(response)
                    });
            }
        });
    };

    editSubCausas = (sub_factor_item) => {
        this.setState({
            formUpdate: {
                id: sub_factor_item.id,
                name: sub_factor_item.title
            },

            modalEdit: true,
        })
    }

    HandleChangeMejora = (e) => {
        this.setState({
            formUpdate: {
                ...this.state.formUpdate,
                name: e.target.value,
                title: e.target.value,
            }
        });
    }

    closeTask = () => {
        this.setState({
            idTask: "",
            showTask: false,
        })
    }

    // --- Editar / eliminar factores (espinas) ---
    toggleFactor = () => {
        this.setState({ modalFactor: !this.state.modalFactor })
    }

    editFactor = (factor) => {
        this.setState({
            modalFactor: true,
            formFactor: { id: factor.id, name: factor.name },
        })
    }

    HandleChangeFactor = (e) => {
        this.setState({
            formFactor: { ...this.state.formFactor, name: e.target.value }
        })
    }

    updateFactor = () => {
        fetch(`/cause/factors/${this.state.formFactor.id}`, {
            method: 'PATCH',
            body: JSON.stringify({ name: this.state.formFactor.name }),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.setState({ modalFactor: false })
                this.loadData()
                this.messageSuccess(data)
            })
    }

    deleteFactor = (factor) => {
        Swal.fire({
            title: "¿Eliminar el factor?",
            text: "Se eliminará la espina y sus componentes.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/cause/factors/${factor.id}`, {
                    method: "delete",
                    headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.loadData()
                        this.messageSuccess(response)
                    })
            }
        })
    }


    render() {
        const board = this.props.cause_analysis.task_board;
        return (
            <React.Fragment>
                <RkHeader
                    title={`${this.props.tenant.app_type == "Mejora" ? "Investigación de causas" : "Análisis causa – raíz"}`}
                    subtitle={"Se aconseja utilizar para encontrar las causas de lo que nos sucede, cuando se trata de un problema, pero también se puede plantear de un modo positivo: causas que influyen en la mejora de algo que pretendemos conseguir"}
                    titleNew={"Nueva espina"}
                    icon="fas fa-toolbox"
                    onClickNew={this.toogle}
                    showNew={true}
                    showFilter={false}
                />

                {this.state.modal && (
                    <FormCreate
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modal}
                        toggle={this.toogle}
                        title={"Nueva espina"}

                        //form props
                        formValues={this.state.form}
                        onChangeForm={this.HandleChange}
                        submitForm={this.HandleClick}
                    />
                )}

                {this.state.modalEdit && (
                    <FormUpdate
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modalEdit}
                        toggle={this.toogleMejora}
                        title={`Actalizar Item`}

                        //form props
                        formValues={this.state.formUpdate}
                        errorValues={this.state.ErrorValues}
                        onChangeForm={this.HandleChangeMejora}
                        submitForm={this.HandleClickUpdate}
                        nameBnt={"Actualizar"}
                    />
                )}

                {this.state.modalFactor && (
                    <FormUpdate
                        backdrop={"static"}
                        modal={this.state.modalFactor}
                        toggle={this.toggleFactor}
                        title={"Editar factor"}

                        formValues={this.state.formFactor}
                        errorValues={this.state.ErrorValues}
                        onChangeForm={this.HandleChangeFactor}
                        submitForm={this.updateFactor}
                        nameBnt={"Actualizar"}
                    />
                )}

                <nav className="rk-breadcrumb" aria-label="breadcrumb">
                    <a href={"/cause/cause_analyses"} data-turbolinks="true">
                        <i className="fas fa-project-diagram"></i> Análisis causa – raíz
                    </a>

                    {this.props.cause_analysis.have_survey && (
                        <React.Fragment>
                            <span className="rk-breadcrumb__sep">/</span>
                            <a
                                href={`/formatos/format_categories/${this.props.cause_analysis.survey.format_category_id}/formats/${this.props.cause_analysis.survey.format_id}/gestion/${this.props.cause_analysis.survey.id}`}
                                data-turbolinks="true"
                            >
                                {this.props.cause_analysis.format_name}
                            </a>
                        </React.Fragment>
                    )}
                </nav>

                <div className="content main-card mb-3 card">
                    <div className="card-body normativity-body">
                        <FishboneChart
                            data={this.state.data}
                            loadData={this.loadData}
                            cause_analysis={this.props.cause_analysis}
                            get_name={this.get_name}
                            tenant={this.props.tenant}
                            factors={this.state.dataTable}
                            editFactor={this.editFactor}
                            deleteFactor={this.deleteFactor}
                        />
                    </div>
                </div>

                <div className="rk-wrap">
                    <div className="rk-tabs">
                        <button
                            className={`rk-tabs__btn ${this.state.activeTab === 'factores' ? 'is-active' : ''}`}
                            onClick={() => this.setState({ activeTab: 'factores' })}
                        >
                            <i className="fas fa-sitemap"></i> Factores y tareas
                        </button>
                        <button
                            className={`rk-tabs__btn ${this.state.activeTab === 'comentarios' ? 'is-active' : ''}`}
                            onClick={() => this.setState({ activeTab: 'comentarios' })}
                        >
                            <i className="far fa-comments"></i> Comentarios
                        </button>
                    </div>
                </div>

                {this.state.activeTab === 'comentarios' && (
                    <div className="content main-card mb-3 card">
                        <div className="card-body normativity-body">
                            <div className="col-md-12 mt-4">
                                <GeneralComments
                                    usuario={this.props.user}
                                    module_name={"Analisis de causa"}
                                    module_comment={this.props.cause_analysis.module_comment_id}
                                    users={this.state.users}
                                    url={this.props.url}
                                />
                            </div>
                        </div>
                    </div>
                )}

                {this.state.activeTab === 'factores' && (
                <React.Fragment>
                <div className="content main-card mb-3 card">
                    <div className="card-body normativity-body">
                        {!this.state.isLoaded ? (
                            <React.Fragment>
                                <div className="rk-table-scroll">
                                <table className="rk-table cause-fb-table">
                                    <thead>
                                        <tr>
                                            <th>Factor</th>
                                            <th>Componente</th>
                                            <th>Tareas</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.dataTable
                                            .filter(factor => factor.sub_factor_items.length > 0)
                                            .sort((a, b) => a.id - b.id)
                                            .flatMap((factor) => (
                                                factor.sub_factor_items.map((items, idx) => (
                                                    <tr key={`f${factor.id}-i${items.id}`}>
                                                        {idx === 0 && (
                                                            <td className="cause-fb-factor" rowSpan={factor.sub_factor_items.length}>
                                                                <span className="cause-fb-factor-name">{factor.name}</span>
                                                                {this.props.tenant.app_type != "beewo" && (
                                                                    <span className="cause-fb-factor-desc">{this.get_name(factor.name)}</span>
                                                                )}
                                                            </td>
                                                        )}

                                                        <td className="cause-fb-comp">
                                                            <div className="cause-fb-comp-row">
                                                                <span className="cause-fb-comp-name">
                                                                    {this.props.tenant.app_type == "beewo"
                                                                        ? items.title
                                                                        : <React.Fragment><b>{items.code}</b> {items.description}</React.Fragment>}
                                                                </span>

                                                                <span className="cause-fb-comp-actions">
                                                                    {this.props.tenant.app_type == "beewo" && (
                                                                        <button className="rk-icon-btn" title="Editar componente" onClick={() => this.editSubCausas(items)}>
                                                                            <i className="fas fa-pen"></i>
                                                                        </button>
                                                                    )}
                                                                    <button className="rk-icon-btn rk-danger" title="Eliminar componente" onClick={() => this.delete(items.id, factor.id)}>
                                                                        <i className="fas fa-trash"></i>
                                                                    </button>
                                                                    <button
                                                                        id={`PopoverLabels${items.id}`}
                                                                        className="rk-icon-btn cause-fb-pin"
                                                                        title="Crear tarea"
                                                                        onClick={() => this.setState({ idTask: items.id })}
                                                                    >
                                                                        <i className="fas fa-thumbtack"></i>
                                                                    </button>

                                                                    <UncontrolledPopover isOpen={this.state.idTask == items.id} placement="bottom" target={`PopoverLabels${items.id}`}>
                                                                        <PopoverHeader>Crear tarea <a className="close-popover" onClick={() => this.setState({ showTask: false, idTask: "", register: {} })}> <i className="fas fa-times"></i></a></PopoverHeader>
                                                                        <PopoverBody>
                                                                            <TaskFormCreate
                                                                                numeral_child_score={items.module_task_id}
                                                                                loadTasks={this.reloadAll}
                                                                                users={this.props.users}
                                                                                closeTask={this.closeTask}
                                                                                task_source_id={this.props.task_source.id}
                                                                                url_source={this.url_source}
                                                                                column_id={board ? board.first_column_id : ""}
                                                                                task_label_ids={items.task_label_id ? [items.task_label_id] : []}
                                                                            />
                                                                        </PopoverBody>
                                                                    </UncontrolledPopover>
                                                                </span>
                                                            </div>
                                                        </td>

                                                        <td className="cause-fb-tasks">
                                                            {items.tasks.length > 0 ? (
                                                                <div className="cause-fb-task-list" style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                                                    {items.tasks.map((task) => (
                                                                        <TasksItems
                                                                            key={task.id}
                                                                            compact={true}
                                                                            task={task}
                                                                            user={this.props.user}
                                                                            users={this.props.users}
                                                                            loadData={this.reloadAll}
                                                                            procesos={this.props.procesos}
                                                                            company={this.props.company}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <span className="cause-fb-tasks-empty">— Sin tareas —</span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))
                                            ))}

                                        {this.state.dataTable.filter(factor => factor.sub_factor_items.length > 0).length === 0 && (
                                            <tr>
                                                <td colSpan="3">
                                                    <div className="rk-empty">
                                                        <i className="far fa-folder-open"></i>
                                                        <p>Agrega componentes con el <b>+</b> de cada espina del diagrama para verlos aquí</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                </div>
                            </React.Fragment>
                        ) : (
                                <Loading />
                            )}
                    </div>
                </div>

                <div className="content main-card mb-3 card">
                    <div className="card-body normativity-body">
                        {board ? (
                            <IndexTaskModule
                                key={this.state.boardKey}
                                task_board={board}
                                user={this.props.user}
                                users={this.props.users}
                                estados={this.props.estados}
                                procesos={this.props.procesos}
                                columns={this.props.columns}
                                labels={this.props.labels}
                                tasks={this.props.tasks}
                                task_sources={this.props.task_sources}
                                company={this.props.company}
                                imageUpload={this.props.imageUpload}
                                key_text={this.props.key_text}
                            />
                        ) : (
                            <div className="text-center p-4 text-muted">Preparando el tablero…</div>
                        )}
                    </div>
                </div>
                </React.Fragment>
                )}

            </React.Fragment>
        );
    }
}


export default CauseAnalysisShow;
WebpackerReact.setup({ CauseAnalysisShow });
